export const insurantRelationMap = {
  1: '本人',
  2: '妻子',
  3: '丈夫',
  4: '儿子',
  5: '女儿',
  6: '父亲',
  7: '母亲',
  23: '其他',
};



// WEBPACK FOOTER //
// ./src/pages/insurance/consts/maps.js